<script>
  import { createEventDispatcher } from 'svelte';
  import Field from '@commercebear/components/Field';
  import PasswordInput from '@commercebear/components/PasswordInput';
  import BrandButton from '$lib/components/BrandButton';
  import { useApi } from '$providers/ApiProvider';
  import { preventDefault } from '$util/event';
  import BrandForm from '../BrandForm';

  const dispatch = createEventDispatcher();
  const api = useApi();

  export let token;

  let newPassword = '';
  let confirmPassword = '';
  let error;

  async function submit() {
    error = undefined;
    if (newPassword !== confirmPassword) {
      error = 'Your passwords do not match.';
      return;
    }
    try {
      await $api.auth.resetPassword({}, { requestBody: { newPassword, token } });
      dispatch('complete', { success: 'Your password has been successfully changed.' });
    } catch (requestError) {
      if (requestError.status === 401) {
        dispatch('expired', { error: 'Your password reset link has expired. Please reset your password again.' });
      } else if (requestError.status === 400) {
        if (requestError.response.body.code === 'InvalidPasswordResetTokenError') {
          dispatch('complete', { message: 'Your password has already been changed. Please login or click "Forgot Password"' });
        } else {
          error = requestError.response.body.message;
        }
      } else {
        error = 'An unexpected error occurred. Please try again.';
      }
    }
  }
</script>

<BrandForm method='POST' testid='reset-password-form' {error}>
  <div class='fields'>
    <Field newBrand>
      <svelte:fragment slot='label'>New Password</svelte:fragment>
      <PasswordInput
        name='password'
        placeholder='New Password'
        newBrand
        bind:value={newPassword}
        testid='reset-password-field' />
    </Field>

    <Field newBrand>
      <svelte:fragment slot='label'>Confirm New Password</svelte:fragment>
      <PasswordInput
        name='confirm-password'
        placeholder='Confirm New Password'
        newBrand
        bind:value={confirmPassword}
        testid='confirm-password-field' />
    </Field>

    <div class='actions'>
      <BrandButton primary type='submit' on:click={preventDefault(submit)} testid='reset-password-button'>
        Reset Password
      </BrandButton>
      <BrandButton secondary on:click={preventDefault(() => dispatch('cancel'))} testid='cancel-button'>
        Cancel
      </BrandButton>
    </div>
  </div>
</BrandForm>

<style lang='postcss'>
  .fields{
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .actions {
    display: flex;
    gap: var(--spacing--m);
  }

  @media (--screen-width--below-desktop) {
    .fields {
      --Button--flex: 1;
    }
  }

  @media (--screen-width--below-tablet) {
    .fields {
      gap: 24px;
    }

    .actions {
      flex-direction: column;
    }
  }
</style>
